/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { AppRoutePath } from '../../common/constants';
import LanguageTexts from '../../common/language';
import { RootState } from '../../common/types';
import AppLoader from '../../components/AppLoader';
import AppTable from '../../components/AppTable';
import { loadPools } from './pools.slice';

const PoolListPage = (): JSX.Element => {
  const { pools: poolsTxt } = LanguageTexts;
  const dispatch = useDispatch();
  const { pools, loading } = useSelector((state: RootState) => state.pools);
  const { user: currentUser } = useSelector((state: RootState) => state.login);
  const [loadRequested, setLoadRequested] = useState(false);

  const columns = React.useMemo(
    () => [
      {
        Header: poolsTxt.pool,
        accessor: 'name',
        Cell: ({
          row: {
            original: { _id, name },
          },
        }: // eslint-disable-next-line @typescript-eslint/no-explicit-any
        any) => {
          return (
            <Link to={`${AppRoutePath.PoolsUpdate.replace(':poolId', _id)}`}>
              {name}
            </Link>
          );
        },
      },
      {
        Header: poolsTxt.amount,
        accessor: 'amount',
      },
      {
        Header: poolsTxt.entry,
        accessor: 'entry',
      },
      {
        Header: poolsTxt.coins,
        accessor: 'coins',
      },
      {
        Header: poolsTxt.maxPlayer,
        accessor: 'maxPlayer',
      },
    ],
    [poolsTxt],
  );

  const data = React.useMemo(
    () =>
      pools?.map(({ _id: poolId, ...restPool }) => {
        return {
          _id: poolId,
          ...restPool,
        };
      }),
    [pools],
  );

  useEffect(() => {
    if (!loadRequested) {
      dispatch(loadPools());
      setLoadRequested(true);
    }
  }, [loadRequested, currentUser, dispatch]);

  if (loading || !loadRequested) {
    return <AppLoader />;
  }

  return (
    <section className="list-table">
      <h1 className="primary-heading mb-4">
        {poolsTxt.pools}
        <Link
          className="btn btn-success"
          style={{ float: 'right', fontSize: 18 }}
          to={AppRoutePath.PoolsCreate}
        >
          {poolsTxt.newPool}
        </Link>
      </h1>
      <AppTable columns={columns} data={data || []} />
    </section>
  );
};

export default PoolListPage;
